import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {RequestBodyVacations, ValidationVacation} from "./InjectionVO";
import {environment} from "../../../environments/environment";
import {AuthService} from "../../auth/services/auth.service";
import {Observable} from "rxjs/Observable";
import * as Excel from "exceljs/dist/exceljs.min.js";
import {TadInHoursFilter} from '../../model/tadInHoursFilter';
import {TadInHoursVO} from '../../model/tadInHoursVO';


@Injectable()
export class ApiService {
  private  _userHierarchy: Array<any> = [];
  private  _userLinkedSiteHierarchy: Array<any> = [];
  protected _history: any;
  get userHierarchy() {
    return this._userHierarchy;
  }

  set userHierarchy(users: Array<any>) {
    this._userHierarchy = users;
  }

  get userHierarchyDirSite() {
    return this._userLinkedSiteHierarchy;
  }

  set userHierarchyDirSite(users: Array<any>) {
    this._userLinkedSiteHierarchy = users;
  }

  constructor(private http: HttpClient, private auth: AuthService) { }

  async getCollaborators(): Promise<any> {
    return new Promise((r) => {
      if (!this.userHierarchy.length) {
        this.getHierarchyUsers().subscribe((res: any) => {
          this.userHierarchy = res.map(e => ([e.teams.map(e => e.users).flat(), e.sitelinkedusers] as any)
            .flat()).flat();
          r(this.userHierarchy)
        })
      } else {
        r(this.userHierarchy)
      }
    })
  }

  async getCollaboratorsDirSite(): Promise<any> {
    return new Promise((r) => {
      if (!this.userHierarchyDirSite.length) {
        this.getHierarchyUsersDirSite().subscribe((res: any) => {
          this.userHierarchyDirSite = res.map(e => ([e.sitelinkedusers] as any).flat()).flat();
          r(this.userHierarchyDirSite)
        })
      } else {
        r(this.userHierarchyDirSite)
      }
    })
  }
  getHierarchyUsers() {
    return this.userHierarchy.length ? Observable.of(this.userHierarchy) :
      this.http.get(environment.api.myshiftUrl + '/teams/all?username=' + this.auth.getUser("userName"));
  }

  getHierarchyUsersDirSite() {
    return this.userHierarchyDirSite.length ? Observable.of(this.userHierarchyDirSite) :
      this.http.get(environment.api.myshiftUrl + '/teams/all?username=' + this.auth.getUser("userName"));
  }
  public saveVacations(body: RequestBodyVacations[]): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.http.post(environment.api.myshiftUrl + "/injection/v2/injectionRealise", JSON.stringify(body))
        .subscribe(resolve, reject)
    })
  }

  public getCurrentVacations(matricule:string, date:string):Observable<RequestBodyVacations>{
    return this.http.get<RequestBodyVacations>(environment.api.myshiftUrl + `/injection/v2/currentInjection/${matricule}?date=${date}`);
  }
  public getCurrentVacationsV2(matricule:string, date:string):Observable<RequestBodyVacations>{
    return this.http.get<RequestBodyVacations>(environment.api.myshiftUrl + `/injection/v2/getCurrentInjection/${matricule}?date=${date}`);
  }

  public checkISAlreadyInjected(matricule:string, date:string):Observable<any>{
    return this.http.get<any>(environment.api.myshiftUrl + `/injection/v2/isExist/${matricule}?date=${date}`);
  }


  public getIsShowInjection(matricule:string, date:string):Observable<boolean>{
    //injection/v2/isShowInjection/A00615?date=2023-07-14
    return this.http.get<boolean>(environment.api.myshiftUrl + `/injection/v2/isShowInjection/${matricule}?date=${date}`);
  }

  public validationVacation(body: ValidationVacation): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.http.post(environment.api.myshiftUrl + "/injection/v2/injectionTraitement", JSON.stringify(body))
        .subscribe(resolve, reject)
    })
  }

  public getMotifs(type: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.http.get(environment.api.myshiftUrl + "/injection/v2/motifsByType", {
        params: {
          type
        }
      }).subscribe(resolve, reject)
    })
  }

  public getHistory(userName: string, date: string, status: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if(this._history) this._history.unsubscribe();

      this._history = this.http.get(environment.api.myshiftUrl + "/historique/fiche/" + userName, {
        params: {
          date,
          status
        }
      }).subscribe(resolve, reject)
    })
  }

  public fetchBlocks(payload: any) {
    return new Promise<any>((resolve, reject) => {
      this._history = this.http.post(environment.api.myshiftUrl + "/injection/v2/currentRealise", payload)
        .subscribe(resolve, () => {
          resolve([])
        })
    })
  }
  generateExcel(header, filename='data') {
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet('injection');
    worksheet.addRow(header);
 /*   workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      fs.saveAs(blob, filename+'.xlsx');
    });*/



    workbook.xlsx.writeBuffer().then((data: any) => {
      console.log("buffer");
      const blob = new Blob([data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      document.body.appendChild(a);
      a.setAttribute("style", "display: none");
      a.href = url;
      a.download = filename+".xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    });
  }

  getAllTadHours(filter: TadInHoursFilter):Observable<TadInHoursVO[]> {
    return this.http.post<TadInHoursVO[]>(environment.api.myshiftUrl + "/tadInHours/getTadInHours", filter);
  }
  saveTadInHours(tadInHoursVO: TadInHoursVO[], matricule: string) {
    return this.http.post(environment.api.myshiftUrl + "/tadInHours/bulkSave?username="+matricule, tadInHoursVO);

  }


  generateExcelFailedInjections(header: string[], data: any[], filename: string) {
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet('injection');
    worksheet.addRow(header);
    data.forEach(d => worksheet.addRow(d));
    workbook.xlsx.writeBuffer().then((data: any) => {
      console.log('buffer');
      const blob = new Blob([data], {
        type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download = filename + '.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/injection/api.service.ts